import React, { useEffect, useState } from "react";
import axios, { AxiosResponse } from "axios";
import Login from "../components/Login";

import AuthService from "../services/authService";
import "./Home.css";

const authService = new AuthService();

const Home: React.FunctionComponent = () => {
    document.title = "Shortener";
    const [processing, setProcessing] = useState(false);
    const [shorted, setShorted] = useState(false);
    const [loadingLink, setLoadingLink] = useState(false);
    const [useCustomName, setUseCustomName] = useState(false);
    const [name, setName] = useState("");
    const [url, setUrl] = useState("");
    const [error, setError] = useState("");
    const signedIn = authService.storage.getItem("authenticated") === "true";

    useEffect(() => {
        const loadLink = async () => {
            const key: string = window.location.search;
            if (key !== "" && key !== "?") {
                setLoadingLink(true);
                const apiUrl: string = `/api/links/${key.substring(1)}`;
                try {
                    const response: AxiosResponse = await axios.get(apiUrl);
                    window.location.href = response.data;
                } catch (error) {
                    if (error.response.status === 404) {
                        setError(`Link with name "${key.substring(1)}" was not found`);
                    } else {
                        console.log(error);
                        setError(error.message);
                    }
                    setLoadingLink(false);
                }
            }
        };

        loadLink();
    }, []);

    const composeLink = (key: string) => {
        return `${window.location.origin}/?${key}`;
    };

    const shortLink = async () => {
        setProcessing(true);
        const token = await authService.getToken();

        const data: any = { url, name };
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            };

            const response: AxiosResponse = await axios.post("/api/links", data, config);
            setUrl(composeLink(response.data));
            setShorted(true);
            setError("");
        } catch (error) {
            console.log(error);
            setError(error.response.data === "" ? error.message : error.response.data);
        }

        setProcessing(false);
    };

    const copyLink = () => {
        const el: any = document.getElementById("link-input");
        el.select();
        document.execCommand("copy");
    };

    const showCustomNameInput = () => {
        setUseCustomName(true);
    };

    const linkChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
        setUrl(e.target.value);
        setShorted(false);
    };

    const nameChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
        setName(e.target.value);
    };

    const renderForm = () => (
        <>
            <div className="login-container">
                <Login signedIn={signedIn} />
            </div>
            <h1 className="title">Shorten your link</h1>

            {signedIn && <>
                <div>
                    <input type="text" id="link-input" className="text-input" placeholder="https://"
                        value={url} onChange={linkChanged} />

                    {shorted ?
                        <button className="action-button" onClick={copyLink}>Copy it</button>
                        :
                        <button className="action-button" onClick={shortLink}
                            disabled={url.length <= 8 || processing}>
                            {processing ? "Working" : "Short it"}
                        </button>
                    }
                </div>
                <div>
                    {useCustomName ?
                        <input type="text" className="text-input" style={{ marginRight: 145 }}
                            placeholder="How do you want to name your link?"
                            value={name} onChange={nameChanged} />
                        :
                        // eslint-disable-next-line
                        <div><a href="#" onClick={showCustomNameInput}>Don't like generated name? Use your own</a></div>
                    }
                </div>
            </>
            }
        </>
    );

    return (
        <>
            {loadingLink ?
                <h1 className="title">Loading link...</h1>
                :
                renderForm()
            }

            {error &&
                <div className="error-message">
                    {error}
                </div>
            }
        </>
    );
};

export default Home;
